// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ArticleRestrictedContent-module-content-3lhmP{margin-top:35px}.ArticleRestrictedContent-module-content-3lhmP .core-text{padding:0}.ArticleRestrictedContent-module-content-3lhmP .ArticleRestrictedContent-module-loading-14SrO{width:100%;display:flex;justify-content:center}.ArticleRestrictedContent-module-content-3lhmP .ArticleRestrictedContent-module-error-3ueDO{margin-block:100px;margin-inline:auto;text-align:center}@media(max-width: 1260px){.ArticleRestrictedContent-module-content-3lhmP{width:90%;margin-block:35px 0;margin-inline:auto}}", ""]);
// Exports
exports.locals = {
	"content": "ArticleRestrictedContent-module-content-3lhmP",
	"loading": "ArticleRestrictedContent-module-loading-14SrO",
	"error": "ArticleRestrictedContent-module-error-3ueDO"
};
module.exports = exports;
